'use client';

import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
import React, { useState } from 'react';

//Partials
import Button from "@/components/partials/button";

//Heroicons
import { ArrowRightCircleIcon } from "@heroicons/react/24/solid";

//Types
import { Config } from '@/types/config.type';

type ButtonElement = {
    text: string;
    url: string;
    target?: string;
}

type ContentItem = {
    imageSrc: string;
    button: {
        scheduler: ButtonElement;
        contact: ButtonElement;
    }
}

type CtaAppointmentBlockProps = {
    data: {
        alignment: string;
        leading: string;
        title: string;
        description: string;
        content: ContentItem;
    }
    config: Config;
}

const CtaAppointmentBlock = ({
    data,
    config
}: CtaAppointmentBlockProps) => {
    const { scrollY } = useScroll();
    const [visible, setVisible] = useState(false);

    useMotionValueEvent(scrollY, "change", (latest) => {
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const footerThreshold = documentHeight - windowHeight - 2000;

        setVisible(latest > 1000 && latest < footerThreshold);
    });

    const { alignment, leading, title, description, content: { button: { scheduler, contact }, imageSrc } } = data;

    const { company, settings } = config;

    return (
        <motion.div
            variants={{
                hidden: { y: "130%" },
                visible: { y: 0 }
            }}
            initial="hidden"
            animate={visible ? "visible" : "hidden"}
            transition={{ duration: 0.35, ease: "easeInOut" }}
            className="fixed bottom-0 left-0 right-0 z-50 sm:bottom-6">
            <div className="container max-w-4xl mx-auto flex items-center justify-between">
                <div className="flex flex-col w-full p-4 rounded-lg shadow-[var(--secondary-color)] shadow-lg border-2 border-[#2d1a3d] sm:flex-row sm:text-left md:p-4 sm:bg-neutral-950 max-sm:border-none max-sm:shadow-none max-sm:text-center">
                    <div className="flex flex-1 max-sm:hidden">
                        <div className="flex flex-col mb-4 sm:mb-0">
                            <h2 className="text-base font-bold md:text-xl">Transform your real estate <br className="inline-block sm:hidden" /> ambitions into reality.</h2>
                            <h6 className="text-sm md:text-lg">Schedule your consultation today.</h6></div>
                    </div>
                    <div className="">
                        {settings.scheduler ? (
                            <Button id={CtaAppointmentBlock.name + scheduler.text} href={scheduler.url} className="flex flex-1 text-sm md:text-lg" ariaLabel={scheduler.text}>
                                <span className="flex items-center">
                                    {scheduler.text}
                                    <ArrowRightCircleIcon className="flex-shrink-0 w-5 h-5 ms-4 -rotate-45 md:w-7 md:h-7" />
                                </span>
                            </Button>
                        ) : (
                            <Button id={CtaAppointmentBlock.name + contact.text} href={
                                "mailto:" + company.email +
                                "?subject=Request for Information" +
                                "&body=Hello " + company.name + ",\n\n"
                            } className="relative inline-block group sm:text-2xl" ariaLabel={contact.text}>
                                <span className="flex items-center">
                                    {contact.text}
                                    <ArrowRightCircleIcon className="flex-shrink-0 w-7 h-7 ms-4 -rotate-45" />
                                </span>
                            </Button>

                        )}
                    </div>

                    {/* <Button id={CtaAppointmentBlock.name + button.text} href="#" className="relative inline-block group sm:text-2xl" ariaLabel={button.text}>
                        <span className="flex items-center">
                            {button.text}
                            <ArrowRightCircleIcon className="flex-shrink-0 w-7 h-7 ms-4 -rotate-45" />
                        </span>
                    </Button> */}
                </div>
            </div>
        </motion.div>
    );
}

export default CtaAppointmentBlock;
